<!--空白页  -->
<template>
  <div class="noAuthority">
    <div class="SkipTip">
      {{ $t('lang.noPerimission') }}<span
        @click="LoginOut"
      >{{ $t('lang.gotoLoginPage') }}</span
      >
    </div>
  </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
export default {
  data () {
    return {
      countDown: 5
    }
  },
  created () {
  },
  mounted () {},
  methods: {
    LoginOut () {
      this.axios.get('/gatewayPlayoutUrl/tvu-playout/user/logout').then((res) => {
        const { errorCode } = res.data
        if (errorCode === '0x0') {
          window.localStorage.setItem('channelSession', '')
          window.sessionStorage.setItem('userChangeInfo', '')
          sessionStorage.setItem('switchAccount', 'false')
          window.location.href =
            `${window.location.protocol}//${res.data.result.redirectUrl}`
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    }
  },
  beforeDestroy () {
  }
}
</script>

<style scoped lang="less">
.noAuthority {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  .SkipTip {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-150px);
    width: 300px;
    text-align: center;
    font-size: 16px;
    span {
      color: rgb(1, 153, 241);
    }
  }
}
</style>
